import store from '@data/store/Store';
import { distinctBy } from '../lo/lo';

export const getMenuCategories = () => {
  const place = store.getState().place.details?.data;

  if (place?.dishes?.length > 0) {
    const categories = place.dishes
      .flatMap(dish => dish.menus)
      .filter(category => !category.parent)
      .concat(place.dishes.flatMap(d => d.menus).filter(c => c.parent).map(c => c.parent))
      .filter(distinctBy('id'))
      .map(c => ({ ...c, subcategories: [] }))
      .sort((d1, d2) => d1.order - d2.order);

    place.dishes
      .flatMap(dish => dish.menus)
      .filter(category => category.parent)
      .filter(distinctBy('id'))
      .forEach(child => categories.find(c => c.id === child.parent.id)?.subcategories.push(child));

    return categories;
  } else {
    return [];
  }
};

export const getCategoryDishes = (category) => {
  const place = store.getState().place.details?.data;

  if (place?.dishes?.length > 0 && category) {
    return place.dishes
      .filter(dish => dish.menus.find(c => c.id === category.id || category.parent?.slug === c.slug));
  } else {
    return [];
  }
};

export const getLikedDishes = () => {
  const place = store.getState().place.details?.data;
  const dishes = place?.dishes || [];
  return dishes.filter(d => d.isLiked);
};

export const getPlaceOrders = () => {
  const place = store.getState().place.details?.data;
  const orders = store.getState().place.menu;
  const dishes = place?.dishes || [];
  return (orders[place?.uri] || []).filter(o => dishes.find(d => d.id === o.id));
};

export const calculateDishPrice = (dish, order) => {
  const basePrice = dish.price;

  const optionPrices = (order.options || []).reduce((sum, { count, option }) => {
    const matchedOption = dish.dishOptionCategories
      ?.flatMap(c => c.dishOptions)
      .find(o => o.id === option.id);

    const optionPrice = matchedOption?.price || 0;
    return sum + optionPrice * count;
  }, 0);

  const totalDishPrice = (basePrice + optionPrices) * order.count;

  return totalDishPrice;
};

export const calculateTotalOrderPrice = () => {
  const place = store.getState().place.details?.data;
  const { dishes } = place || [];

  const orders = store.getState().place.menu[place?.uri] || [];
  return orders.reduce((total, order) => {
    const dish = dishes.find(d => d.id === order.id);
    if (!dish) return total;
    return total + calculateDishPrice(dish, order);
  }, 0);
};

export const getSelectedOptionsNames = (order, dish) => {
  if (!order.options || !order.options.length || !dish.dishOptionCategories) {
    return [];
  }

  const selectedOptions = [];
  
  order.options.forEach(({ count, option }) => {
    // Find the option in dish categories
    const foundOption = dish.dishOptionCategories
      ?.flatMap(cat => cat.dishOptions)
      .find(o => o.id === option.id);
    
    if (foundOption) {
      // Add option name with count if more than 1
      const optionText = count > 1 ? `${foundOption.name} (${count}x)` : foundOption.name;
      selectedOptions.push(optionText);
    }
  });

  return selectedOptions;
};
